namespace GeniuzPOS.ReportMasterData {
    export class Report_1501_NColumns {
        static columnsKey = 'ReportMasterData.Report_1501_N';
    }
}
